import * as Yup from "yup";

const validationSchema = Yup.object({
  username: Yup.string().required("Invalid username"),
  password: Yup.string().required("Invalid username or password"),
});

export default validationSchema;
